export const tr = {
    cancel: 'İptal',
    'crop-title': 'Görsel kırpma',
    'min-size': 'Seçilen görselin kenarlarından biri 450 pikselin altında.',
    'min-size-16-9': 'Seçilen görsel geniş formatta kullanılamaz; görselin boyutu 1080 × 607 pikselin altında.',
    'narrow-scale': 'Seçilen alan çok dar',
    save: 'Kaydet',
    'standart-format': 'Standart görsel',
    tip: 'Reklamda görüntülenecek alanı seçin',
    'wide-format': 'Geniş ekran (16:9)',
    'wide-scale': 'Seçilen alan çok geniş'
};
